import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

const TagAccount = gql`
  mutation TagAccount($accountTag: String!) {
    tagAccount(accountTag: $accountTag)
  }
`;

function useTagAccount() {
  const [addTag] = useMutation(TagAccount);
  const tagAccount = async (accountTag) => {
    await addTag({ variables: { accountTag: accountTag } });
  };

  return {
    tagAccount
  };
}

export default useTagAccount;
